/**
 * Vehicle road worthy check category values
 */
export enum VehicleRoadWorthyCheckRecordCategoryEnum {
	VEHICLE = 'vehicle',
}
